import request from '@/utils/request'

export default class CourseEmailApi {
  protected prefix = 'course'

  sendEmail(courseId: string, params: { subject: string; content: string }) {
    return request.post(`${this.prefix}/${courseId}/send-email`, params)
  }
}
